(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/info/components/similar-games.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/info/components/similar-games.js');
"use strict";


const _React = React,
  useEffect = _React.useEffect;
const SimilarGames = _ref => {
  let game = _ref.game,
    onLoaded = _ref.onLoaded;
  const _svs$eInstant$shared$ = svs.eInstant.shared.hooks.useGamesByTags({
      game
    }),
    loading = _svs$eInstant$shared$.loading,
    _svs$eInstant$shared$2 = _svs$eInstant$shared$.games,
    games = _svs$eInstant$shared$2 === void 0 ? [] : _svs$eInstant$shared$2;
  const TicketsRowWrapper = svs.eInstant.shared.components.TicketsRowWrapper;
  useEffect(() => {
    if (!loading) {
      onLoaded(games.length > 0); 
    }
  }, [loading, games.length, game, onLoaded]);
  if (loading || !games.length) {
    return null;
  }
  const category = {
    title: 'Liknande spel',
    games,
    icon: 'tips'
  };
  return React.createElement(TicketsRowWrapper, {
    category: category
  });
};
setGlobal('svs.eInstant.lobby.info.components.SimilarGames', SimilarGames);

 })(window);